import { html, ref, repeat, when } from '@microsoft/fast-element';
import { getPrefix } from '../utils';
export const getBannerTemplate = (prefix) => html `
  <div class="banner ${(x) => x.dismissAnimation}" ${ref('banner')}>
    <div part="content" class="content">
      <slot name="content">
        ${when((x) => x.notification, html `
            <div>
              <div>${(x) => { var _a; return ((_a = x.notification) === null || _a === void 0 ? void 0 : _a.body) || 'Place holder for notification message'; }}</div>
            </div>
          `)}
      </slot>
    </div>
    <div part="action" class="action">
      <slot name="action" class="action">
        ${when((x) => x.notification, html `
        <${prefix}-button slot="action" appearance="lightweight" @click=${(x) => x.dismiss()}>
          ${(x) => { var _a, _b, _c, _d; return ((_d = (_c = (_b = (_a = x.notification) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.banner) === null || _c === void 0 ? void 0 : _c.dismissingAction) === null || _d === void 0 ? void 0 : _d.label) || 'Ignore'; }}
        </${prefix}-button>`)}
        ${repeat((x) => { var _a, _b; return (_b = (_a = x.notification) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.banner.confirmingActions; }, html `
            <${prefix}-button
              slot="action"
              appearance="lightweight"
              @click=${(x, c) => {
    var _a;
    x === null || x === void 0 ? void 0 : x.action();
    (_a = c.parent) === null || _a === void 0 ? void 0 : _a.dismissNotification();
}}
            >
              ${(x) => x.label}
            </${prefix}-button>
          `)}
      </slot>
    </div>
  </div>
`;
export const foundationBannerTemplate = html `
  ${(x) => getBannerTemplate(getPrefix(x))}
`;
